export const SERVICE_TIME_ZONE = "America/New_York";

export const HOMEPAGE_PAGE_IDS = [
    "phoenix-americas",
    "phoenix-uk",
    "phoenix-europe",
    "phoenix-canada",
    "phoenix-africa",
    "phoenix-asia",
    "phoenix-middleeast",
];

export enum CHANNEL_IDS {
    US = "US",
    ASIA = "ASIA",
    EU = "EU",
    QT = "QT",
    AUSTRALIA = "AUSTRALIA",
    PHOENIX_US = "PHOENIX_US",
}

export enum LINEUP_STREAM_IDS {
    US = "US_LINEUP",
    ASIA = "ASIA_LINEUP",
    EU = "EU_LINEUP",
    QT = "QT_LINEUP",
}

export enum PLAYER_PAGES {
    premium = "premium",
    premium_africa = "premium-africa",
    premium_asia = "premium-asia",
    premium_canada = "premium-canada",
    premium_europe = "premium-europe",
    premium_middle_east = "premium-middle-east",
}

export const ChannelToStreamIds: Record<CHANNEL_IDS, string> = {
    [CHANNEL_IDS.US]: "US_DIGITAL_LIVE",
    [CHANNEL_IDS.ASIA]: "ASIA",
    [CHANNEL_IDS.EU]: "PAN_EUROPE",
    [CHANNEL_IDS.QT]: "QT_DIGITAL_LIVE",
    [CHANNEL_IDS.AUSTRALIA]: "AUSTRALIA",
    [CHANNEL_IDS.PHOENIX_US]: "US_DIGITAL_LIVE",
};

export interface PlayerInfo {
    lineupStreamId: LINEUP_STREAM_IDS | CHANNEL_IDS;
    livePagePath: string;
    channelId: string;
}

export const PageToPlayerInfoMap: Record<PLAYER_PAGES, PlayerInfo> = {
    [PLAYER_PAGES.premium]: {
        lineupStreamId: LINEUP_STREAM_IDS.US,
        livePagePath: "/live",
        channelId: ChannelToStreamIds.US,
    },
    [PLAYER_PAGES.premium_africa]: {
        lineupStreamId: LINEUP_STREAM_IDS.EU,
        livePagePath: "/live/europe",
        channelId: ChannelToStreamIds.EU,
    },
    [PLAYER_PAGES.premium_asia]: {
        lineupStreamId: LINEUP_STREAM_IDS.ASIA,
        livePagePath: "/live/asia",
        channelId: ChannelToStreamIds.ASIA,
    },
    [PLAYER_PAGES.premium_canada]: {
        lineupStreamId: LINEUP_STREAM_IDS.US,
        livePagePath: "/live",
        channelId: ChannelToStreamIds.US,
    },
    [PLAYER_PAGES.premium_europe]: {
        lineupStreamId: LINEUP_STREAM_IDS.EU,
        livePagePath: "/live/europe",
        channelId: ChannelToStreamIds.EU,
    },
    [PLAYER_PAGES.premium_middle_east]: {
        lineupStreamId: LINEUP_STREAM_IDS.EU,
        livePagePath: "/live/europe",
        channelId: ChannelToStreamIds.EU,
    },
};

export const QTPlayerInfo: PlayerInfo = {
    lineupStreamId: LINEUP_STREAM_IDS.QT,
    livePagePath: "/qt/live",
    channelId: ChannelToStreamIds.QT,
};

export type SingleStoryLiveStreamChannels =
    | CHANNEL_IDS.US
    | CHANNEL_IDS.ASIA
    | CHANNEL_IDS.EU
    | CHANNEL_IDS.QT;

export const SingleStoryPlayerInfo: Record<
    SingleStoryLiveStreamChannels,
    PlayerInfo
> = {
    [CHANNEL_IDS.US]: {
        lineupStreamId: CHANNEL_IDS.US,
        livePagePath: "/live",
        channelId: ChannelToStreamIds.US,
    },
    [CHANNEL_IDS.ASIA]: {
        lineupStreamId: CHANNEL_IDS.ASIA,
        livePagePath: "/live/asia",
        channelId: ChannelToStreamIds.ASIA,
    },
    [CHANNEL_IDS.EU]: {
        lineupStreamId: CHANNEL_IDS.EU,
        livePagePath: "/live/europe",
        channelId: ChannelToStreamIds.EU,
    },
    [CHANNEL_IDS.QT]: {
        lineupStreamId: CHANNEL_IDS.QT,
        livePagePath: "/qt/live",
        channelId: ChannelToStreamIds.QT,
    },
};

export const VideoWellScheduleInfo: Record<CHANNEL_IDS, string> = {
    [CHANNEL_IDS.US]: ChannelToStreamIds.US,
    [CHANNEL_IDS.ASIA]: ChannelToStreamIds.ASIA,
    [CHANNEL_IDS.EU]: ChannelToStreamIds.EU,
    [CHANNEL_IDS.QT]: ChannelToStreamIds.QT,
    [CHANNEL_IDS.AUSTRALIA]: ChannelToStreamIds.ASIA,
    [CHANNEL_IDS.PHOENIX_US]: ChannelToStreamIds.PHOENIX_US,
};
